export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "process_reports": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reportes del proceso"])},
          "containers_reports": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reportes por contenedor"])},
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de procesos"])},
          "show_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ver"])}
        }
      },
      "en": {
        "labels": {
          "process_reports": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Process reports"])},
          "containers_reports": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Container reports"])},
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go back to process list"])},
          "show_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Show"])}
        }
      }
    }
  })
}